const translations = {
    authorize: 'Continue to John Deere',
    cancel: 'Cancel',
    climateDescription:
        'Import planting maps, harvest layers, and as-applied data so spray plans can reference yield and hybrid zones alongside your application records.',
    climateKind: 'Agronomy · Bayer Climate',
    comingQ3: 'Coming Q3',
    comingQ4: 'Coming Q4',
    connect: 'Connect',
    connectedSyncing: 'Connected · syncing',
    disconnect: 'Disconnect',
    djiDescription:
        'Stream flight logs, swath coverage, and spray telemetry from Agras T-series platforms into AcreConnect alongside your AAI fleet for unified reporting.',
    djiKind: 'Drone telemetry · Agras T-series',
    eavDescription:
        'Ingest EAVision autonomous mission logs and spray coverage into AcreConnect reports so orchard operators maintain a single record of applied acres across vendors.',
    eavKind: 'Drone telemetry · J-series',
    integrationsLive: '1 live',
    integrationsTotal: '6 integrations',
    johnDeereDescription:
        'Sync fields, boundaries, and operational work records directly from Operations Center. Pulls in field geometry and pushes completed spray jobs back as documented operations.',
    johnDeereKind: 'Farm Management · OAuth 2.0',
    live: 'Live',
    modalBody:
        "You'll be redirected to John Deere's sign-in to authorize AcreConnect. We request read access to fields and boundaries, and write access to post completed spray jobs back as work records.",
    modalStep1: 'Sign in with your MyJohnDeere account',
    modalStep2: 'Select the organization to link',
    modalStep3: 'Review and authorize the requested scopes',
    modalStep4: "You'll return here once sync begins",
    modalTitle: 'Connect Operations Center',
    notifyMe: 'Notify me',
    pageTitle: 'Connections',
    quickBooksDescription:
        'Push completed applications to QuickBooks as invoiceable jobs. Map products, acreage, and custom-rate pricing to customers and classes in your chart of accounts.',
    quickBooksKind: 'Accounting · Intuit',
    readyToConnect: 'Ready to connect',
    sectionHint:
        'Link AcreConnect to field, equipment and accounting systems. Only John Deere Operations Center is currently live — additional integrations ship this quarter.',
    toastConnected: 'John Deere Operations Center connected. Syncing fields…',
    xagDescription:
        'Pull P-series mission records, nozzle data, and chemical logs. Keeps XAG fleet records side-by-side with AAI coverage reports for mixed-fleet operators.',
    xagKind: 'Drone telemetry · P-series',
    zeroConnected: '0 connected'
};

export default translations;
